<template>
  <div class="settings-account" data-testid="settings-account">
    <div class="sa-row">
      <div class="sa-row-info">
        <span class="sa-row-label">{{ STRINGS.settingsHub.account.email }}</span>
        <span class="sa-row-value">{{ auth.user.value?.name ?? '' }}</span>
      </div>
      <button class="sa-row-action" disabled>
        {{ STRINGS.settingsHub.account.changeAction }}
      </button>
    </div>

    <div class="sa-row">
      <div class="sa-row-info">
        <span class="sa-row-label">{{ STRINGS.settingsHub.account.password }}</span>
        <span class="sa-row-value sa-row-value--masked">********</span>
      </div>
      <button class="sa-row-action" disabled>
        {{ STRINGS.settingsHub.account.changeAction }}
      </button>
    </div>

    <p class="sa-coming-soon">{{ STRINGS.settingsHub.account.comingSoon }}</p>
  </div>
</template>

<script setup lang="ts">
import { useAuth } from '@/composables/useAuth';
import STRINGS from '@/constants/strings';

const auth = useAuth();
</script>

<style scoped>
.settings-account {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.sa-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.875rem 1rem;
  background: var(--color-arena-void);
  border: 1px solid var(--color-arena-border);
  border-radius: 0.75rem;
}

.sa-row-info {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.sa-row-label {
  font-size: 0.6875rem;
  font-weight: 600;
  color: var(--color-arena-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.sa-row-value {
  font-size: 0.875rem;
  color: var(--color-arena-text-bright);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sa-row-value--masked {
  letter-spacing: 0.1em;
  color: var(--color-arena-text-dim);
}

.sa-row-action {
  font-family: var(--font-sans);
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--color-energy-primary);
  background: transparent;
  border: 1px solid rgba(201, 168, 76, 0.3);
  border-radius: 0.375rem;
  padding: 0.375rem 0.75rem;
  cursor: pointer;
  transition:
    border-color 150ms ease,
    background-color 150ms ease,
    opacity 150ms ease;
  flex-shrink: 0;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.sa-row-action:hover:not(:disabled) {
  border-color: var(--color-energy-primary);
  background: rgba(201, 168, 76, 0.06);
}

.sa-row-action:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.sa-coming-soon {
  font-size: 0.75rem;
  color: var(--color-arena-text-dim);
  text-align: center;
  font-style: italic;
  margin: 0.5rem 0 0;
}
</style>
